import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { LokiMonitoringService } from './loki-monitoring.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    private injector: Injector,
    private zone: NgZone
  ) { }

  handleError(error: unknown): void {
    console.error("Global Error caught:", error);

    const monitoringService = this.injector.get(LokiMonitoringService);
    this.zone.runOutsideAngular(() => {
      monitoringService.logTypeScriptError(error);
    });
  }
}
